import { render } from "./BaseRunTab.vue?vue&type=template&id=5102dc28&ts=true"
import script from "./BaseRunTab.vue?vue&type=script&lang=ts"
export * from "./BaseRunTab.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__